import { render, staticRenderFns } from "./Recommend.vue?vue&type=template&id=9b2e4f3a&scoped=true"
import script from "./Recommend.vue?vue&type=script&lang=js"
export * from "./Recommend.vue?vue&type=script&lang=js"
import style0 from "./Recommend.vue?vue&type=style&index=0&id=9b2e4f3a&prod&lang=less"
import style1 from "./Recommend.vue?vue&type=style&index=1&id=9b2e4f3a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b2e4f3a",
  null
  
)

export default component.exports